import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataNotFound from "../ErrorPage/DataNotFound";
import s from "./newAdminTransaction.module.css";
import { BiArrowBack } from "react-icons/bi";

const PujaTransactionView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const passedData = location.state?.data;

  if (!passedData) {
    return <DataNotFound message="No transaction data found." />;
  }

  const txn = Array.isArray(passedData) ? passedData[0] : passedData;

  const dash = "—";
  const safe = (v) => (v !== null && v !== undefined && v !== "" ? v : dash);

  const formatDate = (d) => (d ? new Date(d).toLocaleDateString("en-IN") : dash);
  const formatTime = (d) =>
    d ? new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" }) : dash;

  return (
    <>
      <div
        className={s["title"]}
        style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => navigate(-1)}
      >
        <BiArrowBack /> Back
      </div>

      <div style={{ padding: "20px 40px", maxWidth: "1000px", margin: "0 auto" }}>
        <h2 style={{ textAlign: "center", color: "var(--clr-theme)" }}>
          Puja Transaction Details
        </h2>

        <Section title="Transaction Information">
          <DetailRow label="Custom Order ID" value={safe(txn.customOrderId)} highlight />
          <DetailRow label="Order ID" value={safe(txn.orderId)} />
          <DetailRow label="Payment ID" value={safe(txn.paymentId)} />
          <DetailRow label="Currency" value={safe(txn.currency)} />
          <DetailRow label="Amount Paid" value={`₹${safe(txn.amount)}`} highlight />
          <DetailRow label="Puja Amount" value={`₹${safe(txn.pujaAmount)}`} />
          <DetailRow label="Transaction By" value={safe(txn.transaction_by)} />
          <DetailRow label="Mode" value={safe(txn.mode)} />
          <DetailRow label="Status" value={safe(txn.status)?.toUpperCase()} status={txn.status} />
          <DetailRow label="Delivery Status" value={safe(txn.deliveryStatus)} />
          <DetailRow label="Reminder Sent" value={txn.reminderSent ? "Yes" : "No"} />
          <DetailRow
            label="Created At"
            value={`${formatDate(txn.created_at)} ${formatTime(txn.created_at)}`}
          />
          <DetailRow
            label="Updated At"
            value={`${formatDate(txn.updated_at)} ${formatTime(txn.updated_at)}`}
          />
        </Section>
        <Section title="User Details">
          <DetailRow label="User ID" value={safe(txn.userId?._id)} />
          <DetailRow label="Name" value={safe(txn.userId?.name)} />
          <DetailRow label="Phone" value={safe(txn.userId?.phone)} highlight />
          <DetailRow label="Gotra" value={safe(txn.user_info?.gotra)} highlight />
        </Section>
        <Section title="Puja / Event Details">
          <DetailRow label="Event ID" value={safe(txn.eventId?._id)} />
          <DetailRow label="Puja Name" value={safe(txn.eventId?.name)} />
          <DetailRow label="Hindi Title" value={safe(txn.eventId?.titleHindi)} />
          <DetailRow label="Primary God" value={safe(txn.eventId?.primaryGodName)} />
          <DetailRow label="Purpose" value={safe(txn.eventId?.purpose)} />
          <DetailRow label="Puja Price" value={`₹${safe(txn.eventId?.price)}`} />
          <DetailRow label="Puja Date" value={formatDate(txn.pujaDate)} />
        </Section>
        <Section title="Extra Services">
          <DetailRow
            label="No. of Members"
            value={safe(txn.extraServices?.numberOfMembers?.title)}
          />
          <DetailRow
            label="Members Price"
            value={`₹${safe(txn.extraServices?.numberOfMembers?.price)}`}
          />
          <DetailRow
            label="Offering"
            value={safe(txn.extraServices?.offerings?.title)}
          />
          <DetailRow
            label="Offering  Price"
            value={`₹${safe(txn.extraServices?.offerings?.price)}`}
          />
          <DetailRow
            label="Prasad Home Delivery"
            value={safe(txn.extraServices?.prasadHomeDelivery?.title)}
          />
          <DetailRow
            label="Prasad Delivery Price"
            value={`₹${safe(txn.extraServices?.prasadHomeDelivery?.price)}`}
          />
        </Section>

        <Section title="Shipping Details">
          <DetailRow label="Name" value={safe(txn.shippingDetails?.name)} />
          <DetailRow label="Mobile" value={safe(txn.shippingDetails?.mobileNumber)} />
          <DetailRow label="Alternate Mobile" value={safe(txn.shippingDetails?.alternateNumber)} />
          <DetailRow label="Address" value={safe(txn.shippingDetails?.address)} />
          <DetailRow label="City" value={safe(txn.shippingDetails?.city)} />
          <DetailRow label="State" value={safe(txn.shippingDetails?.state)} />
          <DetailRow label="Country" value={safe(txn.shippingDetails?.country)} />
          <DetailRow label="Pincode" value={safe(txn.shippingDetails?.pincode)} />
        </Section>

        <Section title="Attachments">
          <AttachmentBox
            title="Puja Video"
            link={txn.videoUrl}
            textIfEmpty="Video not uploaded"
          />
          <AttachmentBox
            title="Certificate"
            link={txn.certificate?.path}
            textIfEmpty="Certificate not issued"
          />
          <DetailRow
            label="Certificate Issued At"
            value={formatDate(txn.certificate?.issuedAt)}
          />
        </Section>
      </div>
    </>
  );
};

/* ================= REUSABLE COMPONENTS ================= */

const Section = ({ title, children }) => (
  <div
    style={{
      background: "#fff",
      marginTop: "25px",
      padding: "20px",
      borderRadius: "12px",
      boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
    }}
  >
    <h3 style={{ color: "var(--clr-theme)", marginBottom: "15px" }}>{title}</h3>
    {children}
  </div>
);

const DetailRow = ({ label, value, highlight, status }) => (
  <div style={{ marginBottom: "10px" }}>
    <span style={{ width: "180px", display: "inline-block", color: "#555" }}>
      {label}:
    </span>
    <span
      style={{
        fontWeight: highlight ? "bold" : "500",
        color:
          status === "success"
            ? "#0b8a0b"
            : status === "pending"
            ? "#e67e22"
            : highlight
            ? "var(--clr-theme)"
            : "#333",
      }}
    >
      {value || "—"}
    </span>
  </div>
);

const AttachmentBox = ({ title, link, textIfEmpty }) => (
  <div style={{ marginBottom: "10px" }}>
    <strong>{title}: </strong>
    {link ? (
      <a href={link} target="_blank" rel="noreferrer">
        Open ↗
      </a>
    ) : (
      <span style={{ color: "#999" }}>{textIfEmpty}</span>
    )}
  </div>
);
export default PujaTransactionView;